<template>
    <div>
        <Breadcrumbs :items="breadcrumbs"/>
    </div>
</template>

<script>
export default {
    data: () => ({
        breadcrumbs: [
            {
                icon : 'mdi-file-chart'
            },
            {
                text: 'bytypeofcontent'
            }
        ],
    })
}
</script>